import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconFileAttachmentOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M20.934 0H4C2.9 0 2 .9 2 2v28c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V9.076zM28 10.541h-8.541V2H4v28h24zM21.338 3.07l5.59 5.589h-5.59z" clipRule="evenodd" /></svg>;
export default SvgIconFileAttachmentOutlined;